import Menu from 'components/menu';
import React from 'react';

function Navbar() {
  return <Menu />;
}

export default Navbar;
